import React from "react";
import "./navbar.css"; // See below for the matching CSS!

export default function Navbar() {
  return (
    <nav className="navbar medieval-navbar">
      <div className="navbar-content">
        <a href="/Home" className="navbar-logo">
          Quizzards.Ai<span className="navbar-trademark">™</span>
        </a>
        <ul className="navbar-links">
          <li><a href="/Home" className="navbar-link">Home</a></li>
          {/* Add more nav links as needed */}
        </ul>
      </div>
    </nav>
  );
}
